// Formattazione e colori condivisi dalla board ordini
// colori di stato (palette status della skill dataviz): mai da soli, sempre con etichetta o numero
export const LEVEL_COLOR = {
	late: '#d03b3b',
	warn: '#fab219',
	ok: '#0ca30c',
	unknown: '#898781',
	closed: '#c3c2b7',
};

// testo dentro un segmento colorato: bianco, scuro sul giallo e sul grigio chiaro
export const LEVEL_INK = {
	late: '#ffffff',
	warn: '#0b0b0b',
	ok: '#ffffff',
	unknown: '#ffffff',
	closed: '#0b0b0b',
};

export const LEVEL_TEXT = {
	late: 'In ritardo',
	warn: 'Da tenere d’occhio',
	ok: 'Nei tempi',
	unknown: 'Tempi non ancora misurati',
	closed: 'Status chiuso: non va in ritardo',
};

/**
 * 2g 4h · 6h 20m · 35m (come il backend, features/orderboard/timing.js). `hoursOnly` quando il negozio ha
 * gli orari di lavoro: le durate sono ore lavorative e "2g" sarebbe ambiguo, quindi 52h 30m.
 */
export const formatDuration = (ms, hoursOnly = false) => {
	if (ms === null || ms === undefined) return 'n.d.';
	const minutes = Math.max(0, Math.round(ms / 60000));
	if (hoursOnly) {
		const hh = Math.floor(minutes / 60);
		const mm = minutes % 60;
		if (hh) return mm ? `${hh}h ${mm}m` : `${hh}h`;
		return `${mm}m`;
	}
	const d = Math.floor(minutes / 1440);
	const h = Math.floor((minutes % 1440) / 60);
	const m = minutes % 60;
	if (d) return h ? `${d}g ${h}h` : `${d}g`;
	if (h) return m ? `${h}h ${m}m` : `${h}h`;
	return `${m}m`;
};

// i colori degli status arrivano come #RRGGBBAA (picker del BO): three.js vuole #RRGGBB
export const solidColor = (value, fallback = '#90A4AE') => {
	const hex = String(value || '').trim();
	return /^#[0-9a-f]{6}([0-9a-f]{2})?$/i.test(hex) ? hex.slice(0, 7) : fallback;
};

export const escapeHtml = value =>
	String(value === null || value === undefined ? '' : value).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

// status della board (stessi di features/orderboard/timing.js WORKING_STATUS_IDS): gli altri sono "chiusi"
export const WORKING_STATUS_IDS = [
	'60deb4c46fee57191fa7114c', // Da verificare
	'60deb6ee6fee57191fa7114d', // Accettato
	'60deb7186fee57191fa7114e', // Pagato
	'60deb7436fee57191fa71150', // In preparazione
	'60deb7806fee57191fa71153', // Spedito parzialmente
	'60deb72a6fee57191fa7114f', // Spedito
];
